export const selectButtonConfig = {
  colorScheme: {
    light: {},
  },
  css: ({ dt }: any) => `
      .p-selectbutton {
        gap: var(--spacing-12);
        .p-togglebutton {
          border-radius: 6px;
          border: 0;
          background: transparent;
          padding: var(--spacing-8) var(--spacing-12);

          &.p-togglebutton-checked , &:hover {
            background-color: var(--p-primary-100) !important;
            color: var(--p-primary-700)
          }

          .p-togglebutton-content {
            font: var(--font-text-sm-semi-bold);
            color: var(--p-gray-500);
          }
        }
      }
  `,
};
